// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__332Rg","requiredAsterisk":"Info_requiredAsterisk__1dAjp"};